import { createFileRoute } from "@tanstack/react-router";
import heroImg from "@/assets/areas.jpg";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/concierge-services")({
  head: () => ({
    meta: [
      { title: services["concierge-services"].metaTitle },
      { name: "description", content: services["concierge-services"].metaDescription },
      { property: "og:title", content: services["concierge-services"].metaTitle },
      { property: "og:description", content: services["concierge-services"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/concierge-services" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/concierge-services" }, { rel: "preload", as: "image", href: heroImg, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Concierge Services', url: 'https://anchorsrq.com/concierge-services' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "concierge-services", name: 'Property Concierge Services', serviceType: 'Property Concierge', description: 'Property concierge support from Anchor Services for absentee and seasonal Sarasota homeowners — vendor access, deliveries, contractor meets, pre-arrival prep, and on-call coordination as a supporting service to our Home Watch program.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["concierge-services"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["concierge-services"]} heroImg={heroImg} />,
});
